export const themeOptions = [
  {
    '--primary-color': '#1f63af', // 主题颜色
    '--primary-rgb-color': '31, 99, 175',
    name: 'as-blue' // 主题名字
  }
]
